__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__Ml02sa__ariaSlider",
  "ariaSliderTrack": "PlasmicSlider-module__Ml02sa__ariaSliderTrack",
  "background": "PlasmicSlider-module__Ml02sa__background",
  "description": "PlasmicSlider-module__Ml02sa__description",
  "foreground": "PlasmicSlider-module__Ml02sa__foreground",
  "foregroundglobal_themeOrange_override": "PlasmicSlider-module__Ml02sa__foregroundglobal_themeOrange_override",
  "freeBox": "PlasmicSlider-module__Ml02sa__freeBox",
  "sliderThumb__s11Fb": "PlasmicSlider-module__Ml02sa__sliderThumb__s11Fb",
});
